export default __webpack_public_path__ + "static/media/Ruparel.d8c65e35.png";